import RequerimentoLGPD from './views/RequerimentoLGPD.vue'
import AcompanhamentoRequerimento from './views/AcompanhamentoRequerimento.vue'
import AcompanhamentoHistorico from './views/AcompanhamentoHistorico.vue'
import ConfirmaRequerimento from './views/ConfirmaRequerimento.vue'

export const routes = [
    {
        path: '/',
        name: 'requerimento',
        component: RequerimentoLGPD,
        titulo: 'Requerimento LGPD - MPT',
        meta: {
          pageTitle: 'Requerimento LGPD - MPT',
          breadcrumb: [
            {
              text: 'Requerimento LGPD - MPT',
              active: true,
            },
          ],
        },
      },

      {
        path: '/acompanhamento-requerimento',
        name: 'acompanhamento-requerimento',
        component: AcompanhamentoRequerimento,
        titulo: 'Acompanhamento Requerimento',
        meta: {
          pageTitle: 'Acompanhamento Requerimento',
          breadcrumb: [
            {
              text: 'Acompanhamento Requerimento',
              active: true,
            },
          ],
        },
      },
      {
        path: '/acompanhamento-historico',
        name: 'acompanhamento-historico',
        component: AcompanhamentoHistorico,
        titulo: 'Histórico do Requerimento LGPD',
        meta: {
          pageTitle: 'Histórico do Requerimento LGPD',
          breadcrumb: [
            {
              text: 'Histórico do Requerimento LGPD',
              active: true,
            },
          ],
        },
      },
      {
        path: '/confirma-requerimento',
        name: 'confirma-requerimento',
        component: ConfirmaRequerimento,
        titulo: 'Confirmação Requerimento LGPD',
        meta: {
          pageTitle: 'Confirmação Requerimento LGPD',
          breadcrumb: [
            {
              text: 'Confirmação Requerimento LGPD',
              active: true,
            },
          ],
        },
      }, 
/*
     {
       path: "*",
       name: 'requerimento',
       component: RequerimentoLGPD,
       titulo: 'Requerimento LGPD - MPT',
       meta: {
         pageTitle: 'Requerimento LGPD - MPT',
         breadcrumb: [
           {
             text: 'Requerimento LGPD - MPT',
             active: true,
           },
         ],
       },
      },*/
];



// WEBPACK FOOTER //
// ./src/routes.js